import { Link } from 'gatsby'
import { buildImageObj, getBlogUrl } from '../lib/helpers'
import { imageUrlFor } from '../lib/image-url'
import { categoryTags, authorTags } from '../lib/tags'
import { IPostNode } from '../types/postsListing'

import {
  leadMediaThumb,
  title,
  excerpt as excerptStyle,
} from './blog-post-preview.module.css'

function BlogPostPreview({
  publishedAt,
  slug: { current },
  mainImage,
  categories,
  authors,
  excerpt,
  title: postTitle,
}: IPostNode) {
  return (
    <div key={current}>
      <Link to={getBlogUrl(publishedAt, current)}>
        <div className={leadMediaThumb}>
          {mainImage && mainImage.asset && (
            <img
              src={imageUrlFor(buildImageObj(mainImage))
                .width(600)
                .height(Math.floor((9 / 16) * 600))
                .auto('format')
                .url()}
              alt={mainImage.alt || ''}
            />
          )}
        </div>
      </Link>
      <div>
        {categories && categoryTags(categories)}
        <Link to={getBlogUrl(publishedAt, current)}>
          <h3 className={title}>{postTitle}</h3>
        </Link>
        {excerpt && <div className={excerptStyle}>{excerpt}</div>}
        {authorTags(authors, publishedAt)}
      </div>
    </div>
  )
}

export default BlogPostPreview
